/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/scheduled_messages`);
  }

  schedule(conversationId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/scheduled_messages`,
      payload
    );
  }

  update(conversationId, id, payload) {
    return axios.patch(
      `${this.url}/${conversationId}/scheduled_messages/${id}`,
      payload
    );
  }

  cancel(conversationId, id) {
    return axios.delete(
      `${this.url}/${conversationId}/scheduled_messages/${id}`
    );
  }

  sendNow(conversationId, id) {
    return axios.post(
      `${this.url}/${conversationId}/scheduled_messages/${id}/send_now`
    );
  }
}

export default new ScheduledMessagesApi();
